/**
 * ExportImportPanelWrapper — wraps ExportImportPanel with flight plan hook state.
 */
import { ExportImportPanel } from './ExportImportPanel';
import { useFlightPlan } from '../services/FlightPlanContext';

export function ExportImportPanelWrapper() {
  const { currentPlan, saveImportedPlan } = useFlightPlan();
  return <ExportImportPanel currentPlan={currentPlan} onImport={saveImportedPlan} />;
}
